var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ul',{staticClass:"container"},[_c('li',[_c('router-link',{attrs:{"to":_vm.preLink}},[_vm._v("Todo")])],1),_vm._l((_vm.anos),function(ano){return _c('li',{key:ano.id},[_c('router-link',{attrs:{"to":`${_vm.preLink}/${ano.ano}`}},[_vm._v(_vm._s(ano.ano))])],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }